var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3516_5923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2822 10.2732C15.7182 9.89176 15.9683 9.34083 15.9683 8.76166V7.48231C16.4119 7.48231 16.7716 7.12261 16.7716 6.67896V5.87561C16.7716 5.43197 16.4119 5.07227 15.9683 5.07227H7.13147C6.68783 5.07227 6.32812 5.43197 6.32812 5.87561V6.67896C6.32812 7.12261 6.68783 7.48231 7.13147 7.48231V8.76166C7.13147 9.34083 7.38154 9.89176 7.81753 10.2732L10.3449 12.4848V12.9233L7.81753 15.1351C7.38154 15.5164 7.13147 16.0673 7.13147 16.6465V17.9258C6.68783 17.9258 6.32812 18.2855 6.32812 18.7292V19.5325C6.32812 19.9762 6.68783 20.3359 7.13147 20.3359H15.9683C16.4119 20.3359 16.7716 19.9762 16.7716 19.5325V18.7292C16.7716 18.2855 16.4119 17.9258 15.9683 17.9258V16.6465C15.9683 16.0673 15.7182 15.5164 15.2822 15.1351L12.7549 12.9233V12.4848L15.2822 10.2732ZM7.13147 5.87561H15.9683V6.67896H7.13147V5.87561ZM7.93482 7.48231H15.1649V8.76166C15.1646 9.02526 15.0775 9.2814 14.9172 9.49068H8.18273C8.02229 9.2814 7.93521 9.02526 7.93482 8.76166V7.48231ZM15.9683 19.5325H7.13147V18.7292H15.9683V19.5325ZM12.2259 13.5284L14.7533 15.74C15.0147 15.9686 15.1647 16.2991 15.1649 16.6465V17.9258H7.93482V16.6465C7.93502 16.2991 8.08505 15.9686 8.3465 15.74L10.8738 13.5284C11.0484 13.3756 11.1484 13.1552 11.1482 12.9233V12.4848C11.1484 12.253 11.0484 12.0325 10.8738 11.8799L9.06158 10.294H14.0403L12.2279 11.8799C12.0528 12.0321 11.9519 12.2528 11.9516 12.4848V12.9233C11.9516 13.1552 12.0516 13.3756 12.2259 13.5284Z",
    fill: "#14A800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1484 13.9092H11.9518V14.7125H11.1484V13.9092Z",
    fill: "#14A800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1484 15.5156H11.9518V16.319H11.1484V15.5156Z",
    fill: "#14A800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9933 12.7041C21.9943 18.3558 17.4992 22.9827 11.8499 23.1451C6.20058 23.3075 1.44718 18.9463 1.12356 13.3039C0.799752 7.66161 5.02341 2.78543 10.6541 2.3008L9.69286 3.44639L10.3083 3.9626L11.8575 2.11487C12.0001 1.94482 11.9782 1.69142 11.8081 1.54884L9.96038 0L9.44554 0.617416L10.5054 1.50745C4.45581 2.07172 -0.0520394 7.33878 0.324726 13.4031C0.701295 19.4674 5.82656 24.1361 11.8995 23.9472C17.9725 23.7584 22.7977 18.78 22.7967 12.7041H21.9933Z",
    fill: "#14A800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3452 9.07234L22.0987 8.79403C22.0034 8.53612 21.8979 8.27742 21.7806 8.02441L21.0498 8.35862C21.1575 8.59358 21.2567 8.83345 21.3452 9.07234Z",
    fill: "#14A800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6968 2.70206C16.4487 2.57438 16.1947 2.45533 15.9433 2.34863L15.6289 3.08765C15.8627 3.18728 16.0988 3.2977 16.3297 3.41656L16.6968 2.70206Z",
    fill: "#14A800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9759 12.0896L22.7792 12.0425C22.7628 11.765 22.7363 11.4867 22.6988 11.2139L21.9023 11.32C21.9357 11.573 21.9602 11.8317 21.9759 12.0896Z",
    fill: "#14A800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7725 10.558L22.5589 10.3932C22.5019 10.1222 22.4348 9.85052 22.3581 9.58496L21.5859 9.80718C21.6571 10.0533 21.7197 10.3055 21.7725 10.558Z",
    fill: "#14A800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8585 6.37502L20.4967 5.88783C20.3292 5.66797 20.1513 5.45145 19.9677 5.24512L19.3652 5.77839C19.5372 5.97001 19.7043 6.17085 19.8585 6.37502Z",
    fill: "#14A800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7019 7.66904L21.4052 7.28071C21.2714 7.03966 21.1273 6.79862 20.9766 6.56738L20.3037 7.00632C20.4436 7.22089 20.5777 7.44251 20.7019 7.66904Z",
    fill: "#14A800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1653 2.0506C14.8993 1.96058 14.6306 1.88075 14.3669 1.8125L14.166 2.59055C14.411 2.6535 14.6605 2.72784 14.9074 2.81139L15.1653 2.0506Z",
    fill: "#14A800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.553 1.63447C13.2814 1.58603 13.0038 1.54661 12.7287 1.51758L12.6455 2.3174C12.9011 2.34348 13.1584 2.37996 13.4108 2.42546L13.553 1.63447Z",
    fill: "#14A800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1169 3.57243C17.8892 3.40886 17.6562 3.25391 17.4236 3.11133L17.0039 3.79621C17.2196 3.92821 17.4366 4.07295 17.6466 4.22515L18.1169 3.57243Z",
    fill: "#14A800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3916 4.64256C19.1934 4.44937 18.9856 4.26167 18.7744 4.08496L18.2578 4.70002C18.4541 4.86458 18.6473 5.03933 18.8325 5.21898L19.3916 4.64256Z",
    fill: "#14A800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3516_5923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 24,
    fill: "white",
    transform: "translate(0.301758)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time_icon.88f69c46f8a3f60ae3f00658a3a5458f.svg";
export { ForwardRef as ReactComponent };